import React, {useEffect} from 'react'
import {Link} from 'react-router-dom'
import {noticeActions} from "../../../store/actions";
import {connect} from "react-redux";
import moment from "moment";
import history from "../../../route/history";
import {commons} from "../../../hook/common";

const MobileMain = props => {

    useEffect(() => {
        if (!commons.isMobile()) {
            history.replace('/');
            return;
        }
        props.load();
    }, [])

    const openUth = () => {
        if (commons.isMobile()) {
            history.push('/openLink');
        }
    }

    const goLink = url => {
        history.push(url);
    }

    return (
        <React.Fragment>
            <div className="mobile-main-box">
                <div className="mobile-main-inner">
                    <div className="mobile-top-box">
                        <h4>전자증명서 지갑</h4>
                        <div className="banBox">
                            <ul className="">
                                <li className="data">
                                    <Link title="증명서발급" to="/service/apply/1"><span className='icon-notification'></span></Link>
                                    {/*<span>증명서발급</span>*/}
                                </li>
                                <li className="ban">
                                    <span className='icon-notification' onClick={openUth}/>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="mobile-main-table m-t-20">
                        <h4>공지사항</h4>


                        {
                            props.data?.content?.map(notice => {
                                return <Link title="공지사항" to={'/notice/' + notice.noticeSeq}><div className="mobile-table-inner">
                                        <div className="flex-sb-m">
                                            <div className="mobile-notice-title">{notice.noticeSj}</div>
                                            <div className="mobile-notice-date">{moment(notice.regDt).format('YYYY.MM.DD')}</div>
                                            <div className="mobile-notice-view">{notice.viewCount}</div>
                                        </div>
                                    </div>
                                </Link>
                            })
                        }

                    </div>
                </div>

                <div className="mobile-notification-button">
                    <button className="btn btn-red" onClick={() => goLink('/service/inbox')}>받은 증명서</button>
                    <button className="btn" onClick={() => goLink('/service/sent')}>보낸 증명서</button>
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        data : state.notice?.data,

    }
}
const actionCreators = {
    load: noticeActions.load,

}

export default connect(
    mapStateToProps,
    actionCreators
)(MobileMain)
